import { useDispatch, useSelector } from "react-redux"
import {
  deleteUser,
  findAllUser,
  getUser,
  saveUser,
} from "../store/features/userSlice"
import { Template } from "../components/Template"
import {
  Alert,
  Backdrop,
  Chip,
  CircularProgress,
  Divider,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
} from "@mui/material"
import { useEffect, useState } from "react"
import { USER_MODEL } from "../constants"
import AddIcon from "@mui/icons-material/Add"
import { MyTable } from "../components/MyTable"
import { getAux } from "../store/features/auxSlice"
import { MyModal } from "../components/MyModal"
import moment from "moment/moment"
import TuneIcon from "@mui/icons-material/Tune"
import { getConf } from "../store/features/confSlice"
import { UsersForChapterChart } from "../components/charts/user/UsersForChapterChart"
import { getAuth } from "../store/features/authSlice"
import { MyImagePickerInput } from "../components/inputs/MyImagePickerInput"

const { REACT_APP_STATIC_ROUTE: STATIC_ROUTE } = process.env

export const UsersScreen = () => {
  const user = useSelector(getUser)
  const aux = useSelector(getAux)
  const conf = useSelector(getConf)
  const auth = useSelector(getAuth)
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(5)
  const dispatch = useDispatch()
  const [selected, setSelected] = useState({ ...USER_MODEL })
  const [isOpen, setIsOpen] = useState(false)
  const [filters, setFilters] = useState({
    id: "",
    role: 2,
    personType: 1,
    name: "",
    surname: "",
    businessName: "",
    ruc: "",
    state: 1,
  })

  useEffect(() => {
    if (!!selected) {
      console.log(selected)
    }
  }, [selected])

  useEffect(() => {
    setPage(0)
    getAll()
  }, [filters])

  useEffect(() => {
    getAll()
  }, [page, rowsPerPage])

  useEffect(() => {
    switch (filters.role) {
      case 1:
      case 2:
        setFilters({ ...filters, personType: 1 })
        break
      case 3:
      case 4:
        setFilters({ ...filters, personType: 2 })
        break
    }
  }, [filters.role])

  useEffect(() => {
    switch (selected.role) {
      case 1:
      case 2:
        setSelected({ ...selected, personType: 1 })
        break
      case 3:
      case 4:
        setSelected({ ...selected, personType: 2 })
        break
    }
  }, [selected.role])

  const getAll = () => {
    dispatch(
      findAllUser({
        start: page,
        limit: rowsPerPage,
        id: filters.id,
        role: filters.role,
        personType: filters.personType,
        name: filters.name,
        surname: filters.surname,
        businessName: filters.businessName,
        ruc: filters.ruc,
        state: filters.state,
        jwt: auth.data.jwtToken,
      })
    )
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value)
    setPage(0)
  }

  const selectItem = (row) => {
    setSelected(row)
    setIsOpen(true)
  }

  const handleClose = () => {
    setIsOpen(false)
    setSelected({ ...USER_MODEL })
  }

  const handleChangeFilter = (e) => {
    const name = e.target.name
    const value = e.target.value
    setFilters({ ...filters, [name]: value })
  }

  const handleClickNewItem = () => {
    setSelected({ ...USER_MODEL })
    setIsOpen(true)
  }

  const onSave = () => {
    dispatch(saveUser({ user: selected, jwt: auth.data.jwtToken }))
  }

  const onDelete = () => {
    dispatch(deleteUser({ id: selected.id, jwt: auth.data.jwtToken }))
  }

  const handleChangeElement = (e) => {
    setSelected({ ...selected, [e.target.name]: e.target.value })
  }

  const columns = [
    {
      field: "cover",
      headerName: "Portada",
      width: 100,
      align: "left",
      render: (params) => (
        <img
          src={STATIC_ROUTE + params.row.cover}
          width={"80%"}
          style={{ borderRadius: 10 }}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null // prevents looping
            currentTarget.src = "/no-image-available.png"
          }}
        />
      ),
    },
    { field: "id", headerName: "Id", width: 200, align: "left" },
    {
      field: "name",
      headerName: "Nombre",
      width: 300,
      align: "left",
      render: (params) => (
        <>
          {params.row.personType === 1 && (
            <span>{params.row.name + " " + params.row.surname}</span>
          )}
          {params.row.personType === 2 && (
            <span>{params.row.businessName}</span>
          )}
        </>
      ),
    },
    {
      field: "ruc",
      headerName: filters.personType === 1 ? "DNI" : "RUC",
      width: 100,
      align: "left",
    },
    {
      field: "insertionDate",
      headerName: "Fecha de creación",
      width: 200,
      align: "left",
      render: (params) => (
        <span>
          {moment(params.row.insertionDate).format("YYYY-MM-DD, hh:mm:ss a")}
        </span>
      ),
    },
    {
      field: "",
      headerName: "Acciones",
      width: 100,
      align: "center",
      render: (params) => (
        <IconButton
          sx={{ cursor: "pointer" }}
          onClick={() => selectItem(params.row)}
        >
          <TuneIcon />
        </IconButton>
      ),
    },
  ]

  const modal = () => {
    return (
      <MyModal
        updateTitle={
          <span>
            <span>Editar </span>
            <span style={{ color: "tan" }}>
              {aux.data.roles.find((item) => item.id === selected.role).value}:{" "}
            </span>
            <span style={{ color: "gray" }}>
              {selected.personType === 1 ? (
                <span>
                  {selected.name} {selected.surname}
                </span>
              ) : (
                <span>{selected.businessName}</span>
              )}
            </span>
          </span>
        }
        insertTitle="Crear nuevo usuario"
        isOpen={isOpen}
        handleClose={handleClose}
        selected={selected}
        onSave={onSave}
        onDelete={onDelete}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Datos generales" />
            </Divider>
          </Grid>
          {aux.data.roles.some((rl) => rl.id === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Rol de usuario</InputLabel>
                <Select
                  value={selected.role}
                  label="Rol de usuario"
                  name="role"
                  onChange={handleChangeElement}
                >
                  {aux.data.roles.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {[1, 2, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Tipo de persona</InputLabel>
                <Select
                  value={selected.personType}
                  label="Tipo de persona"
                  name="personType"
                  onChange={handleChangeElement}
                >
                  {aux.data.personTypes.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {[1, 2, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={selected.state}
                  label="Estado"
                  name="state"
                  onChange={handleChangeElement}
                >
                  {aux.data.states.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          {[1, 2, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <MyImagePickerInput
                label="Portada"
                name="cover"
                value={selected.cover}
                onChange={handleChangeElement}
                accept={"image/*"}
              />
            </Grid>
          )}
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Control de acceso" />
            </Divider>
          </Grid>
          {[1, 2, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <TextField
                label="ID"
                variant="outlined"
                fullWidth
                name="id"
                value={selected.id}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[1, 2].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <TextField
                label="Contraseña"
                variant="outlined"
                fullWidth
                name="password"
                type="password"
                value={selected.password}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[1, 2].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Forzar cambio de contraseña</InputLabel>
                <Select
                  value={selected.changedPassword}
                  label="Forzar cambio de contraseña"
                  name="changedPassword"
                  onChange={handleChangeElement}
                >
                  <MenuItem value="N">Sí</MenuItem>
                  <MenuItem value="Y">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {[3].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Cuenta verificada</InputLabel>
                <Select
                  value={selected.verifiedAccount}
                  label="Cuenta verificada"
                  name="verifiedAccount"
                  onChange={handleChangeElement}
                >
                  <MenuItem value="Y">Sí</MenuItem>
                  <MenuItem value="N">No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          )}
          {[1].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Nivel de acceso</InputLabel>
                <Select
                  value={selected.accessLevel}
                  label="Nivel de acceso"
                  name="accessLevel"
                  onChange={handleChangeElement}
                >
                  {conf.data.accessLevels.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Datos personales" />
            </Divider>
          </Grid>
          {[1, 2].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label="Nombre"
                variant="outlined"
                fullWidth
                name="name"
                value={selected.name}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[1, 2].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label="Apellido"
                variant="outlined"
                fullWidth
                name="surname"
                value={selected.surname}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label="Nombre corporativo"
                variant="outlined"
                fullWidth
                name="businessName"
                value={selected.businessName}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>
          )}
          {[1, 2, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label={selected.personType === 1 ? "DNI" : "RUC"}
                variant="outlined"
                fullWidth
                name="ruc"
                value={selected.ruc}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[1, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label="Teléfono"
                variant="outlined"
                fullWidth
                name="phone"
                value={selected.phone}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[1, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label="Correo electrónico"
                variant="outlined"
                fullWidth
                name="email"
                value={selected.email}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 50 }}
              />
            </Grid>
          )}
          {[1, 3, 4].some((rl) => rl === selected.role) && (
            <Grid item xs={12}>
              <TextField
                label="Página web"
                variant="outlined"
                fullWidth
                name="web"
                value={selected.web}
                onChange={handleChangeElement}
                inputProps={{ maxLength: 100 }}
              />
            </Grid>
          )}
          <Grid item xs={12} my={2}>
            <Divider>
              <Chip label="Institucional" />
            </Divider>
          </Grid>
          {[2].some((rl) => rl === selected.role) && (
            <Grid item xs={6}>
              <FormControl fullWidth>
                <InputLabel>Capítulo</InputLabel>
                <Select
                  value={selected.chapter}
                  label="Capítulo"
                  name="chapter"
                  onChange={handleChangeElement}
                >
                  {conf.data.chapters.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}
        </Grid>
      </MyModal>
    )
  }

  return (
    <Template>
      {!!selected && modal()}
      <Grid item xs={12}>
        <Paper
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <UsersForChapterChart />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
          <Grid
            container
            spacing={2}
            sx={{ paddingY: 2 }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item xs={10}>
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Rol de usuario</InputLabel>
                <Select
                  value={filters.role}
                  label="Rol de usuario"
                  name="role"
                  onChange={handleChangeFilter}
                >
                  {aux.data.roles.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                sx={{ marginRight: 1 }}
                label="ID"
                variant="outlined"
                name="id"
                value={filters.id}
                onChange={handleChangeFilter}
              />
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Tipo de persona</InputLabel>
                <Select
                  value={filters.personType}
                  label="Tipo de persona"
                  name="personType"
                  onChange={handleChangeFilter}
                >
                  {aux.data.personTypes.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <FormControl sx={{ marginRight: 1 }}>
                <InputLabel>Estado</InputLabel>
                <Select
                  value={filters.state}
                  label="Estado"
                  name="state"
                  onChange={handleChangeFilter}
                >
                  {aux.data.states.map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.value}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={10}>
              <TextField
                sx={{ marginRight: 1 }}
                label={filters.personType === 1 ? "DNI" : "RUC"}
                variant="outlined"
                name="ruc"
                value={filters.ruc}
                onChange={handleChangeFilter}
              />
              {filters.personType === 1 && (
                <TextField
                  sx={{ marginRight: 1 }}
                  label="Nombre"
                  variant="outlined"
                  name="name"
                  value={filters.name}
                  onChange={handleChangeFilter}
                />
              )}
              {filters.personType === 1 && (
                <TextField
                  sx={{ marginRight: 1 }}
                  label="Apellido"
                  variant="outlined"
                  name="surname"
                  value={filters.surname}
                  onChange={handleChangeFilter}
                />
              )}
              {filters.personType === 2 && (
                <TextField
                  sx={{ marginRight: 1 }}
                  label="Nombre corporativo"
                  variant="outlined"
                  name="businessName"
                  value={filters.businessName}
                  onChange={handleChangeFilter}
                />
              )}
            </Grid>
            <div style={{ marginLeft: 1 }}>
              <IconButton
                size="large"
                color="primary"
                onClick={handleClickNewItem}
              >
                <AddIcon fontSize="large" />
              </IconButton>
            </div>
          </Grid>
          {user.status === "loading" && (
            <Backdrop
              sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={user.status === "loading"}
            >
              <CircularProgress color="inherit" />
            </Backdrop>
          )}
          {user.status === "failed" && (
            <Alert severity="error">{String(user.error)}</Alert>
          )}
          {user.status === "succeeded" && (
            <div style={{ minHeight: 400, width: "100%" }}>
              <MyTable
                columns={columns}
                rows={user.data}
                page={page}
                handleChangePage={handleChangePage}
                rowsPerPage={rowsPerPage}
                handleChangeRowsPerPage={handleChangeRowsPerPage}
                totalElements={user.totalElements}
              />
            </div>
          )}
        </Paper>
      </Grid>
    </Template>
  )
}
